
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"110","height":"36","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".25","y":".25","width":"109.5","height":"35.5","rx":"7.75","fill":"#fff","stroke":"#AEB1BA","stroke-width":".5"}}),_c('path',{attrs:{"d":"M19.967 17.293a1 1 0 000 1.414l6.364 6.364a1 1 0 001.414-1.414L22.088 18l5.657-5.657a1 1 0 00-1.414-1.414l-6.364 6.364zm70.099 1.414a1 1 0 000-1.414l-6.364-6.364a1 1 0 00-1.415 1.414L87.944 18l-5.657 5.657a1 1 0 001.415 1.414l6.364-6.364zM20.674 19H89.36v-2H20.674v2z","fill":"#AEB1BA"}})])
          )
        }
      }
    